import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type ConflictAccordionClickEventParams = {
	priceChange: string;
	newTotalPrice: string;
	selectedSolutionGroup: string;
	open: boolean;
	label: string;
	solutionGroup: { name: string }[];
};

export class ConflictAccordionClickEvent extends BaseEvent {
	constructor({
		priceChange,
		newTotalPrice,
		open,
		label,
		solutionGroup,
		selectedSolutionGroup,
	}: ConflictAccordionClickEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Content,
				eventName: `configuration assistant - click to ${open ? 'open' : 'close'} accordion`,
			},
			attributes: {
				componentName: 'configuration-assistant',
				label,
				elementName: 'accordion',
				value: `${priceChange.split(' ').join('')}~${newTotalPrice}`,
				relatedElements: [{ elementName: 'solution group', elementValue: selectedSolutionGroup }],
			},
			additionalObjects: {
				componentInfo: {
					componentID: 7,
				},
				attributes: {
					implementer: 1,
					version: '1.0.0',
					priceChange: priceChange.split(' ').join(''),
					totalPrice: newTotalPrice,
					solutionGroup,
				},
				page: {
					pageInfo: {
						pageID: `configuration assistant - conflict layer`,
					},
				},
			},
		});
	}
}
